<template>
  <layout>
    <template slot="header">
      {{ localTitle }}
    </template>

    <template>
      <component
        :items="items"
        v-model="localValue"
        v-bind="$attrs"
        :is="component"
        class="px-4"
      />
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text :loading="false" @click.stop="close">
        cancel
      </v-btn>
      <v-btn color="primary" text :loading="false" @click.stop="apply">
        save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import appInput from './appInput';
import appDropdown from './appDropdown';
import appChips from './appChips';
import appVariable from './appVariable';

export default {
  name: 'EditField',
  props: {
    typeField: {
      type: String,
      default: ''
    },
    type: {
      type: [String]
    },
    value: {},
    title: {
      type: [String]
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    appInput,
    appDropdown,
    appChips,
    appVariable,
    Layout
  },
  data() {
    return {
      localValue: ''
    };
  },
  computed: {
    localTitle() {
      if (!this.title) return '';
      const str = this.title.toLowerCase();
      return str[0].toUpperCase() + str.slice(1);
    },
    showPopup() {
      return !!this.type;
    },
    component() {
      switch (this.type) {
        case 'dropdown':
          return 'appDropdown';
        case 'chips':
          return 'appChips';
        case 'variable':
          return 'appVariable';
        default:
          return 'appInput';
      }
    }
  },
  methods: {
    apply() {
      this.$emit('input', this.localValue);
      this.close();
    },
    close() {
      this.$emit('close');
    }
  },
  created() {
    this.localValue = this.value;
  }
};
</script>
